import { Link, useSearchParams } from "react-router-dom";
import "./Goods.css";
import { ARTICL_NAME, CART_MAIN_LINK, CATALOG_ITEM_LINK, CATALOG_MAIN_LINK, IMG_PLACEHOLDER_PRODUCT, MAIN_URL } from "../../../assets/utils/constants";
import { useContext, useEffect, useState } from "react";
import mainApi from "../../../assets/api/MainApi";
import { ConfigContext } from "../../../assets/contexts/configContext";
import { buildCategoryPath, getCorrectWordForm, parsePrice, parseTitleForParts } from "../../../assets/utils/utils";
import { CartIcon } from "../../../assets/icons/icons";

function Goods({ cart, handleAddToCart, handleRemoveFromCart, products, setProducts }) {
  const [isPreloaderVisible, setPreloaderVisible] = useState(true);


  const config = useContext(ConfigContext)
  const { initialConstants } = config
  const { SHOP_ID_FOR_API, } = initialConstants
  const cartLocalStorageKey = `cart_${SHOP_ID_FOR_API}`;

  useEffect(() => {
    if (!cart || cart.length === 0) {
      setProducts([]);
      setPreloaderVisible(false);
      return;
    }

    setPreloaderVisible(true);
    mainApi
      .getManyItems({
        data: {
          shop_id: SHOP_ID_FOR_API,
          ids: cart.map((item) => item._id),
        },
      })
      .then((res) => {
        console.log(res);
        const filtered_cart = cart.filter((item) => {
          let product = res.data.find(
            (product_item) => product_item._id === item._id
          );
          if (!product) {
            removeFromCart({
              ...product,
              ...item,
            }, true);
            return false;
          }

          // Check if all options are present in the product
          const validOptions = item.options.every((option) => {
            const productOption = product.options.find(
              (product_option) => option.name === product_option.name
            );
            if (!productOption) {
              return false;
            }

            // Check if the option value is present in the product
            const optionValue = productOption.values.find(
              (product_option_value) => option.value === product_option_value.value
            );
            if (!optionValue) {
              return false;
            }

            return true;
          });

          if (!validOptions) {
            removeFromCart({
              ...product,
              ...item,
            }, true);
            return false;
          }

          return true;
        });

        const updatedProducts = filtered_cart.map((item) => {
          let product = res.data.find(
            (product_item) => product_item._id === item._id
          );

          const options = item.options.map((option) => {
            const productOption = product.options.find(
              (product_option) => option.name === product_option.name
            );
            const optionValue = productOption.values.find(
              (product_option_value) => option.value === product_option_value.value
            );

            return {
              name: productOption.name,
              value: optionValue.value,
              in_stock: optionValue.in_stock,
              price: optionValue.price,
            };
          });

          return {
            ...product,
            ...item,
            options: options,
          };
        });

        setProducts(updatedProducts);
        localStorage.setItem(cartLocalStorageKey, JSON.stringify(filtered_cart));
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setPreloaderVisible(false);
      });
  }, [cart]);

  function addToCart(item) {
    const product_to_card = {
      ...item,
      //   selected_size: item.selected_size,
      count: 1,
    };
    console.log(product_to_card);
    handleAddToCart(product_to_card);
  }

  function removeFromCart(item, is_all) {
    const product_to_card = {
      ...item,
      //   selected_size: item.selected_size,
    };
    console.log(product_to_card);
    handleRemoveFromCart(product_to_card, is_all);
  }

  return (
    <>
      {!isPreloaderVisible || products ? (
        <div className="goods">
          {products && products.length > 0 ? (
            products.map((item, i) => {
              console.log(item)
              const in_stock = item ? item.options.length === 1 ? item.options[0].in_stock : item.price_data.in_stock : null
              const price = item ? item.options.length === 1 ? item.options[0].price : item.price_data.price : null
              return (
                <>
                  <div
                    className="goods__card"
                    key={`goods__card_${item._id}${item.options ? item.options.map(option => option.name).join(', ') : "no-size"
                      }`}
                  >
                    <Link
                      className="goods__card-img-box"
                      to={`/${CATALOG_MAIN_LINK}/${buildCategoryPath(item.categories[0].parents.reverse(), item.categories[0].parents.length - 1)}/${CATALOG_ITEM_LINK}/${item._id}` + `${item.options && item.options.length > 0 ? `?${new URLSearchParams({ options: JSON.stringify(item.options) })}` : ''}`}
                    >
                      <img
                        className={`goods__card-img`}
                        src={item.files && item.files.length > 0 ? item.files[0].urls.orig : IMG_PLACEHOLDER_PRODUCT}
                        alt=""
                      ></img>
                      {item.price_data.discount && item.price_data.discount > 0 ?
                        <h3 className='goods__price-discount'>-{item.price_data.discount}%</h3>
                        :
                        null
                      }
                    </Link>
                    <div className="goods__card-content">
                      <Link
                        // className="goods__card-img-box"
                        className="goods__card__info-icon_mobile"
                        to={`/${CATALOG_MAIN_LINK}/${buildCategoryPath(item.categories[0].parents.reverse(), item.categories[0].parents.length - 1)}/${CATALOG_ITEM_LINK}/${item._id}` + `${item.options && item.options.length > 0 ? `?${new URLSearchParams({ options: JSON.stringify(item.options) })}` : ''}`}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M6.99661 14C6.03935 14 5.13853 13.817 4.29415 13.4511C3.44977 13.0897 2.70473 12.586 2.05902 11.94C1.41784 11.294 0.914369 10.5486 0.548621 9.70378C0.182874 8.85899 0 7.95773 0 7C0 6.04227 0.182874 5.14101 0.548621 4.29622C0.914369 3.45144 1.41784 2.70829 2.05902 2.0668C2.70473 1.42078 3.44751 0.914811 4.28737 0.548887C5.13175 0.182962 6.03258 0 6.98984 0C7.95162 0 8.8547 0.182962 9.69908 0.548887C10.5435 0.914811 11.2885 1.42078 11.9342 2.0668C12.5799 2.70829 13.0856 3.45144 13.4514 4.29622C13.8171 5.14101 14 6.04227 14 7C14 7.95773 13.8171 8.85899 13.4514 9.70378C13.0856 10.5486 12.5799 11.294 11.9342 11.94C11.2885 12.586 10.5435 13.0897 9.69908 13.4511C8.8547 13.817 7.95388 14 6.99661 14ZM5.75714 10.8964H8.60861C8.77117 10.8964 8.90663 10.8467 9.015 10.7473C9.12337 10.6434 9.17755 10.5102 9.17755 10.3475C9.17755 10.1939 9.12337 10.0652 9.015 9.96128C8.90663 9.85286 8.77117 9.79865 8.60861 9.79865H7.82971V6.47822C7.82971 6.26589 7.77778 6.09422 7.67392 5.96321C7.57007 5.8322 7.4188 5.7667 7.22013 5.7667H5.87905C5.72101 5.7667 5.58781 5.82091 5.47944 5.92933C5.37107 6.03775 5.31688 6.16651 5.31688 6.31559C5.31688 6.47822 5.37107 6.61149 5.47944 6.71539C5.58781 6.81478 5.72101 6.86447 5.87905 6.86447H6.59023V9.79865H5.75714C5.5991 9.79865 5.46363 9.85286 5.35075 9.96128C5.24238 10.0652 5.1882 10.1939 5.1882 10.3475C5.1882 10.5102 5.24238 10.6434 5.35075 10.7473C5.46363 10.8467 5.5991 10.8964 5.75714 10.8964ZM6.95598 4.6757C7.2269 4.6757 7.45493 4.58083 7.64006 4.39109C7.82519 4.20136 7.91776 3.97548 7.91776 3.71346C7.91776 3.43788 7.82519 3.20749 7.64006 3.02227C7.45493 2.83253 7.2269 2.73766 6.95598 2.73766C6.68957 2.73766 6.46154 2.83253 6.27189 3.02227C6.08224 3.20749 5.98742 3.43788 5.98742 3.71346C5.98742 3.97548 6.08224 4.20136 6.27189 4.39109C6.46154 4.58083 6.68957 4.6757 6.95598 4.6757Z" fill="black" />
                        </svg>
                      </Link>
                      <div className="goods__card-heading">
                        <div className="goods__card-title-and-controls">
                          <h3 className="goods__card-title">{parseTitleForParts(item.name).title}</h3>
                          <p className="goods__card-subtitle">{parseTitleForParts(item.name).subtitle}</p>
                          <p className="goods__card-article">{item?.parameters?.find((item2) => item2.name === ARTICL_NAME) ? item?.parameters?.find((item2) => item2.name === ARTICL_NAME).value : ''}</p>
                          {in_stock ?
                            <div>
                              {item.count > in_stock ?
                                <h3 className="goods__not-in-stock-hint">В наличии: {in_stock} {getCorrectWordForm(in_stock)}</h3>
                                :
                                null
                              }
                            </div>
                            :
                            <div className="goods__not-in-stock">
                              <h3 className="goods__not-in-stock-title">Нет в наличии</h3>
                              <button
                                className="goods__not-in-stock-btn"
                                type="button"
                                onClick={() => {
                                  removeFromCart(item, true)
                                }}>
                                <h3 className="goods__not-in-stock-btn-text">Удалить из корзины</h3>
                              </button>
                            </div>
                          }
                        </div>
                        <svg className="goods__card__line-separator_pc" xmlns="http://www.w3.org/2000/svg" width="2" height="74" viewBox="0 0 2 74" fill="none">
                          <path d="M1 0V74" stroke="#E3E3E5" />
                        </svg>
                        <div className="goods__card__line-separator_mobile"></div>
                        <div className="goods__price">
                          {item.price_data.discount && item.price_data.discount > 0 ?
                            <h3 className='goods__price-value '><span className='goods__price-value-discounted'>{parsePrice(Number(price), 'USD')}</span> {parsePrice(Number(price) - Number(price) / 100 * Number(item.price_data.discount), 'USD')}</h3>
                            :
                            <h3 className='goods__price-value'>{parsePrice(price, 'USD')}</h3>
                          }
                          {/* <h3 className="goods__price-value">
                        {parsePrice(item.price_data?.discount ? (
                          Number(item.price_data?.price) -
                          (Number(item.price_data?.price) / 100) *
                          Number(item.price_data?.discount)
                        )
                          : item.price_data?.price, 'USD')}
                      </h3>
                      {item.price_data?.discount ? (
                        <>
                          <p className="goods__price-discount">
                            -
                            {Number(item.price_data?.discount).toLocaleString()}
                            %
                          </p>
                          <p className="goods__price-previous">
                            {Number(item.price_data?.price)}
                          </p>
                        </>
                      ) : null} */}
                        </div>

                        <div className="goods__controls">
                          <button
                            className="goods__control goods__control_type_left"
                            type="button"
                            onClick={() => {
                              removeFromCart(item);
                            }}
                          >
                            <svg className="goods__control" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                              <rect width="40" height="40" rx="4" fill="#F1F1F1" />
                              <path d="M14 20L26 20" stroke="black" stroke-width="2" stroke-linecap="round" />
                            </svg>
                          </button>
                          <div className="goods__control-counter">
                            <p className={`goods__control-counter-text ${item.count > in_stock ? 'goods__control-counter-text_invalid' : ''}`}>
                              {item.count}
                            </p>
                          </div>
                          <button
                            className={`goods__control goods__control_type_right ${Number(item.count) + 1 > Number(in_stock) ? 'goods__control_inactive' : ''}`}
                            type="button"
                            onClick={() => {
                              addToCart(item);
                            }}
                          >
                            <svg className="goods__control" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                              <rect width="40" height="40" rx="4" fill="#F1F1F1" />
                              <path d="M20 14V26" stroke="black" stroke-width="2" stroke-linecap="round" />
                              <path d="M14 20L26 20" stroke="black" stroke-width="2" stroke-linecap="round" />
                            </svg>
                          </button>
                        </div>
                      </div>
                      {item.options && item.options.length > 0 ?
                        <div className="goods__params">
                          {item.options.map((option) => (
                            <div className="goods__param">
                              <p className="goods__param-name">{option.name}</p>
                              <div className="goods__param-line"></div>
                              <p className="goods__param-value">{option.value}</p>
                            </div>
                          ))}

                        </div>
                        : null}

                      {/* <div className="goods__card-discriptions">


                            <div className="goods__card-discription">

                                <div className="goods__discription-detail">
                                    <span className='goods__discription-detail-name'>Размер</span>
                                    <div className="goods__discription-detail-line"></div>
                                    <span className='goods__discription-detail-meaning'>W28 L32</span>
                                </div>

                                <div className="goods__discription-detail">
                                    <span className='goods__discription-detail-name'>Размер</span>
                                    <div className="goods__discription-detail-line"></div>
                                    <span className='goods__discription-detail-meaning'>W28 L32</span>
                                </div>

                                <div className="goods__discription-detail">
                                    <span className='goods__discription-detail-name'>Размер</span>
                                    <div className="goods__discription-detail-line"></div>
                                    <span className='goods__discription-detail-meaning'>W28 L32</span>
                                </div>

                                <div className="goods__discription-detail">
                                    <span className='goods__discription-detail-name'>Размер</span>
                                    <div className="goods__discription-detail-line"></div>
                                    <span className='goods__discription-detail-meaning'>W28 L32</span>
                                </div>

                            </div>

                        </div> */}
                    </div>
                  </div>
                  {/* {i === products.length - 1 && products.length > 1 ?
                    <svg className="goods__card__line" xmlns="http://www.w3.org/2000/svg" width="894" height="2" viewBox="0 0 894 2" fill="none">
                      <path d="M0 1L894 0.999922" stroke="#D4D4D4" stroke-width="0.5" />
                    </svg>
                    : null} */}
                </>
              )
            })
          ) : (
            <div className="no-goods">
              <CartIcon mainClassName={'no-goods__empty-icon'} strokeClassName={'no-goods__empty-icon-stroke'} />
              <h3 className="no-goods__title">Корзина пуста</h3>
              <Link className="no-goods__go-main" to="/">
                <p className="no-goods__go-main-text">‹ Вернуться на главную</p>
              </Link>
            </div>
          )}
        </div >
      ) : null
      }
    </>
  );
}

export default Goods;
